import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 311",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M236 302L9 75a28 28 0 010-40L35 9C46-2 64-2 75 9l181 180L437 9c11-11 29-11 40 0l26 26c11 11 11 29 0 40L276 302a28 28 0 01-40 0z" })
});
export default SvgChevronDown;
